import {
  IonCol,
  IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  IonInput,
  IonRow,
} from "@ionic/react";
import { SearchById } from "../../../models/home/SearchLoadByReferenceId.model";
import { getNotificationBellIconState } from "../../../selectors/selector";
import {
  SEARCH_BY_LOAD,
} from "../../../utils/constants";
import { getFormatRoles } from "../../../utils/formatData";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { createStructuredSelector } from "reselect";
import { ProfileMenu } from "../profileMenu/profileMenu";
import "./header.scss";

const Header = (props: any) => {
  const history = useHistory();
  const { newNotificationsCount } = props.getWebNotificationsData;
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [referenceId, setReferenceId] = useState<string>("");
  const [notificationCount, setNotificationCount] = useState<number>(0);
  const closeModal = (value: boolean) => {
    setShowMenu(value);
  };

  useEffect(() => {
    setNotificationCount(newNotificationsCount);
  }, [newNotificationsCount]);

  const searchByLoadId = () => {
    // Creating modal for Search Load by reference number
    const searchLoadByIdModal = new SearchById();
    const referenceIdTrim = referenceId.trim();
    // Input data for SearchBY reference number to call the graphQL query
    const userRole = getFormatRoles();
    searchLoadByIdModal.userId = props.userDetails?.memberDetailsResponse?.member?.upn;
    searchLoadByIdModal.carrierId = props.userDetails?.memberDetailsResponse?.member?.carrierId;
    searchLoadByIdModal.page = 0;
    searchLoadByIdModal.carrierScac =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.carrierInfo &&  props.userDetails.memberDetailsResponse.carrierInfo.carrierScac) || "";
    searchLoadByIdModal.carrierTier =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.carrierInfo &&  props.userDetails.memberDetailsResponse.carrierInfo.carrierTier) || "";
    searchLoadByIdModal.managedEquipmentCapability =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.carrierInfo &&  props.userDetails.memberDetailsResponse.carrierInfo.managedEquipmentCapability) ||
      null;
    searchLoadByIdModal.nonManagedEquipmentCapability =
      (props.userDetails && props.userDetails.memberDetailsResponse &&
        props.userDetails.memberDetailsResponse.carrierInfo &&  props.userDetails.memberDetailsResponse.carrierInfo.nonManagedEquipmentCapability) ||
      null;
    searchLoadByIdModal.userRole = userRole.join(",");
    searchLoadByIdModal.loadNumberAlias = referenceIdTrim;

    // Dispatching action & Calling the API for Search load by reference number
    if (referenceIdTrim.length === 0) {
      return;
    }
    props.searchByReferenceId(
      searchLoadByIdModal.getRequestPayload(),
      false,
      ()=>setReferenceId("")
    );
  };

  return (
    <IonHeader className="sni-header-wrapper">
      <IonGrid>
        <IonRow class="ion-align-items-center">
          <IonCol size="1">
            <div className="logo-wrapper">
              <img src="assets/icon/sni-Logo.png" alt="" />
            </div>
          </IonCol>
          <IonCol size="4">
            <IonRow>
              <IonCol size="2.5" size-lg="2" />
              <IonCol size="7.5" size-lg="5.5">
                <IonRow className="search-input" >
                  <IonCol size="11" size-lg="10">
                    <IonInput
                      placeholder={SEARCH_BY_LOAD}
                      value={referenceId}
                      onKeyUp={(
                        event: React.KeyboardEvent<HTMLIonInputElement>
                      ) => {
                        if (event.key == "Enter" || event.charCode == 13) {
                          searchByLoadId();
                        }
                      }}
                      onIonChange={(e: any) => { setReferenceId(e.target.value) }} />
                  </IonCol>
                  <IonCol size="1" size-lg="2" onClick={() => {
                    searchByLoadId();
                  }}>
                    <IonIcon className="search-icon" src="assets/icon/search-group.svg" />
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonCol>
          <IonCol size="7" className="profile-wrapper">
            <IonRow>
              <IonCol size="10" size-lg="10.5" className="profile-name-section">
                <div
                  className="profile-notification"
                  onClick={() => {
                    history.push("/app/notifications");
                  }}
                >
                  <IonIcon
                    src={
                      props.notificationBellIconState
                        ? "assets/icon/Notifications_orange.svg"
                        : "assets/icon/Notification.svg"
                    }
                  />
                  {newNotificationsCount > 0 && (
                    <div className="notification-count">
                      {newNotificationsCount}
                    </div>
                  )}
                </div>
                <div className="profile-name">
                  {props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName || props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.lastName ? (
                    <>
                      <span>Welcome,</span>
                      <span className="bold">{props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName}</span>
                    </>
                  ) : null}
                </div>
              </IonCol>
              <IonCol
                size="2"
                size-lg="1.5"  
                className="center ion-text-start"
                onClick={() => closeModal(!showMenu)}
              >
                <IonImg className="profile-icon" src="assets/icon/man.svg" />
                <IonIcon
                  className="profile-drop-down"
                  src="assets/icon/grid-down-arrow-thin.svg"
                />
              </IonCol>
            </IonRow>
          </IonCol>
        </IonRow>
      </IonGrid>
      <ProfileMenu
        showMenu={showMenu}
        userDetails={{ firstName :props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.firstName, 
          lastName : props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.lastName,
          userPrincipalName :props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn,
          carrierId :props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId}}
        closeModal={closeModal}
      />
    </IonHeader>
  );
};

const mapStateToProps = createStructuredSelector({
  notificationBellIconState: getNotificationBellIconState(),
});

export default connect(mapStateToProps)(Header);
